import UserBookmarkShareFilterOption from "models/enumerations/filtering/user-bookmarks/user-bookmark-share-filter-option";
import { useHistory, useLocation } from "react-router";
import { RouteUtils } from "utilities/route-utils";

const useFilterBookmarks = (paramIdToAppend?: string | number) => {
    const { pathname, search } = useLocation();
    const { replace } = useHistory();

    const shareFilterKey = paramIdToAppend
        ? `shareFilter_${paramIdToAppend}`
        : "shareFilter";
    const skipKey = paramIdToAppend ? `skip_${paramIdToAppend}` : "skip";

    const {
        [shareFilterKey]: shareFilter = UserBookmarkShareFilterOption.All,
    } = RouteUtils.queryStringToObject<{
        [shareFilterKey]: number;
    }>(search);

    const onShareFilterChange = (newVal) => {
        const { shareFilter: oldShareFilter, ...otherParams } =
            RouteUtils.queryStringToObject<{
                [shareFilterKey]: boolean;
                [key: string]: any;
            }>(search);
        replace(
            RouteUtils.appendQueryParams(pathname, {
                ...otherParams,
                [shareFilterKey]: newVal,
                [skipKey]: 0,
            })
        );
    };

    return {
        shareFilter,
        shareFilterKey,
        onShareFilterChange,
    };
};

export default useFilterBookmarks;
